import React, { useEffect, useMemo } from "react";
import DashboardLayout from "components/layouts/dashboard-layout";
import { useNavigate, useSearchParams } from "react-router-dom";
import OverviewUploadButtons from "./components/upload-buttons";
import OverviewDiscography from "./components/discography";
import OverviewSpecialFeatures from "./components/special-features";
import { jwtDecode } from "jwt-decode";
import api from "services/axiosInstance";
import { SetUser } from "services/user/setUser";
import { GetActiveArtist } from "services/user/getUser";

interface IDecodedJwt {
  accessToken: string;
  refreshToken: string;
}
const DashboardOverview = () => {
  const [searchParams] = useSearchParams();
  const Jwt = searchParams.get("auth");
  const navigate = useNavigate();

  const artist = GetActiveArtist();

  const GetDetailsOnLogin = async (Jwt: string) => {
    if (!Jwt) {
      return;
    }
    try {
      const Jwtdata = jwtDecode<IDecodedJwt>(Jwt, { header: true });
      localStorage.setItem("accessToken", Jwtdata.accessToken);
      localStorage.setItem("refreshToken", Jwtdata.refreshToken);

      const { data } = await api.get("/users/profile");
      SetUser(data);
    } catch (e) {
      navigate("/");
    }
  };

  useEffect(() => {
    GetDetailsOnLogin(Jwt || "");
  }, []);

  const AddDisabled = useMemo(() => {
    if (!artist) {
      return true;
    }
    return false;
  }, [artist]);
  return (
    <DashboardLayout>
      <>
        <OverviewUploadButtons AddDisabled={AddDisabled} />
        <OverviewDiscography />
        <OverviewSpecialFeatures />
      </>
    </DashboardLayout>
  );
};

export default DashboardOverview;
